import React from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientEducationHub = () => {
  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden">
        
        {/* HERO SECTION */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#f4f7f6" }}>
          <div className="container py-lg-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h6 className="text-success font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "2px" }}>
                  Learn & Grow
                </h6>
                <h1 className="font-weight-bold montserrat text-primary mb-4" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  Education <span className="text-success">Hub.</span>
                </h1>
                <p className="font-size-18 text-muted line-hight-3 mb-0">
                  Explore our library of guides, toolkits, and resources designed for parents, educators, and childcare providers.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* RESOURCES SECTION */}
        <section className="py-5 my-4">
          <div className="container py-lg-4">
            
            {/* Filter Buttons */}
          

            <div className="row g-4">
              
              {/* Resource Card 1 (PDF Guide) */}
              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 p-4 transition-hover">
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    {/* <span className="badge bg-success bg-opacity-10 text-success font-size-12 font-weight-bold px-3 py-2 rounded-pill">Guide (PDF)</span> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#083B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-3 text-primary">Early Signs of Developmental Delays</h4>
                  <p className="text-muted font-size-15 mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                  <a href="#" className="text-success font-weight-bold text-decoration-none mt-auto d-flex align-items-center">
                    Download Now <span className="ms-2">→</span>
                  </a>
                </div>
              </div>

              {/* Resource Card 2 (Toolkit) */}
              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 p-4 transition-hover">
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    {/* <span className="badge bg-primary bg-opacity-10 text-primary font-size-12 font-weight-bold px-3 py-2 rounded-pill">Toolkit</span> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#083B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-3 text-primary">Classroom Inclusion Strategies</h4>
                  <p className="text-muted font-size-15 mb-4">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p>
                  <a href="#" className="text-success font-weight-bold text-decoration-none mt-auto d-flex align-items-center">
                    Download Now <span className="ms-2">→</span>
                  </a>
                </div>
              </div>

              {/* Resource Card 3 (Video) */}
              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 p-4 transition-hover">
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    {/* <span className="badge bg-danger bg-opacity-10 text-danger font-size-12 font-weight-bold px-3 py-2 rounded-pill">Video (Webinar)</span> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#083B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-3 text-primary">Navigating IEP Meetings</h4>
                  <p className="text-muted font-size-15 mb-4">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                  <a href="#" className="text-success font-weight-bold text-decoration-none mt-auto d-flex align-items-center">
                    Watch Now <span className="ms-2">→</span>
                  </a>
                </div>
              </div>

              {/* Resource Card 4 (Article) */}
              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 p-4 transition-hover">
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    {/* <span className="badge bg-warning bg-opacity-10 text-warning font-size-12 font-weight-bold px-3 py-2 rounded-pill">Article</span> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#083B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
                  </div>
                  <h4 className="font-weight-bold font-size-22 mb-3 text-primary">The Importance of Early Screening</h4>
                  <p className="text-muted font-size-15 mb-4">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                  <a href="#" className="text-success font-weight-bold text-decoration-none mt-auto d-flex align-items-center">
                    Read Article <span className="ms-2">→</span>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
      <ClientFooter />
    </>
  );
};

export default ClientEducationHub;